package gr.tech.pdfgenerator.util

object CONSTANTS {
    const val FONT_FAMILY = "Poppins"
    const val FONT_FAMILY2 = "Montserrat"
    const val FONT_FAMILY_TN = "Times New Roman"

    const val ROWS_PER_FETCH_REQ = 20

    object PROJECT_TYPES {
        const val MSA = 1
        const val LIGHTING_PROPOSAL = 2
        const val TIER_THREE = 3
    }
}

/*
    To Improve:
    - Not have Urls lowercase. Should be routes or something.
    - Include the backend URL in these, idk why I kept them separate in api calls.
*/
object BACKEND {
    const val IS_DEV: Boolean = false
    val BACKEND_URL = if (IS_DEV) "http://localhost:8081" else "/api"

    object ROUTES {
        const val USER_OAUTH_LOGIN = "/login-auth"
        const val USER_SIGN_OUT = "/logout"

        const val PROJECTS = "/projects"
        const val PROJECTS_SAVE = "/projects/save"
        const val PROJECTS_UPDATE = "/projects/update"
        const val PROJECTS_DELETE = "/projects/delete"
        const val PROJECTS_DUPE = "/projects/dupe"

        const val PROJECT_PDF = "/projects/pdf"
        const val PROJECT_PDF_SAVE = "/projects/pdf/save"
        const val PROJECT_PDF_DOWNLOAD = "/projects/pdf/download"
        const val PROJECT_PDF_DELETE = "/projects/pdf/delete"
    }
}

object RES {
    // Cache busting version - update this for each release to invalidate browser cache
    const val CACHE_BUST = "v2026.1"

    object GENERAL {
        const val grlogo = "grlogo.png"
        const val grlogocenter = "grlogocenter.png"

        const val CURR_YEAR = "2026"

        const val FULL_ADDRESS = "4417 Crescent Ave. Everett, WA, 98203"
        const val STREET_ADDRESS = "4417 Crescent Ave."
        const val CITY_STATE_ZIP_ADDRESS = "Everett, WA, 98203"

        const val CEO_NAME = "Dylan Collins"
        const val CEO_TITLE = "CEO"
    }

    object MSA {
        const val BASE_PATH = "/msa"
        const val PAGE_1 = "${BASE_PATH}/page_01.png?cb=${CACHE_BUST}"
        const val PAGE_2 = "${BASE_PATH}/page_02.png?cb=${CACHE_BUST}"
        const val PAGE_3 = "${BASE_PATH}/page_03.png?cb=${CACHE_BUST}"
        const val PAGE_4 = "${BASE_PATH}/page_04.png?cb=${CACHE_BUST}"
        const val PAGE_5 = "${BASE_PATH}/page_05.png?cb=${CACHE_BUST}"
        const val PAGE_6 = "${BASE_PATH}/page_06.png?cb=${CACHE_BUST}"
        const val PAGE_7 = "${BASE_PATH}/page_07.png?cb=${CACHE_BUST}"
        const val PAGE_8 = "${BASE_PATH}/page_08.png?cb=${CACHE_BUST}"
        const val PAGE_9 = "${BASE_PATH}/page_09.png?cb=${CACHE_BUST}"
        const val PAGE_10 = "${BASE_PATH}/page_10.png?cb=${CACHE_BUST}"
        const val PAGE_11 = "${BASE_PATH}/page_11.png?cb=${CACHE_BUST}"
    }

    object PROJECT_PROPOSAL {
        const val BASE_PATH = "/projectproposal"
        const val PAGE_1 = "${BASE_PATH}/firstbg.png?cb=${CACHE_BUST}"
        const val PAGE_2 = "${BASE_PATH}/summarybg.png?cb=${CACHE_BUST}"
        const val PAGE_3 = "${BASE_PATH}/cashflowbg.png?cb=${CACHE_BUST}"
        const val PAGE_4 = "${BASE_PATH}/costwaitingbg.png?cb=${CACHE_BUST}"
        const val PAGE_5 = "${BASE_PATH}/savinganalysisbg.png?cb=${CACHE_BUST}"
        const val PAGE_6 = "${BASE_PATH}/financingbg.png?cb=${CACHE_BUST}"
        const val PAGE_7 = "${BASE_PATH}/leasingbg.png?cb=${CACHE_BUST}"
        const val PAGE_8 = "${BASE_PATH}/envimpactbg.png?cb=${CACHE_BUST}"
        const val PAGE_9 = "${BASE_PATH}/formulasbg.png?cb=${CACHE_BUST}"
        const val PAGE_10 = "${BASE_PATH}/termsbg.png?cb=${CACHE_BUST}"
    }

    object TIER_THREE {
        const val DOCUMENT_YEAR  = "2026"
    }
}

object INPUTS {
    object GENERAL {
        const val companyAddressInput = "companyAddressInput"
        const val companyCityInput = "companyCityInput"
        const val companyStateInput = "companyStateInput"
        const val companyUtilityInput = "companyUtilityInput"
        const val companyZipInput = "companyZipInput"
        const val companyRepresentativeInput = "companyRepresentativeInput"
        const val facilityAddressInput = "facilityAddressInput"
        const val effectiveDateInput = "effectiveDateInput"
        const val documentExpInput = "documentExpInput"
        const val customerNameInput = "customerNameInput"
        const val projectNameInput = "projectNameInput"
        const val salesforceDealNameInput = "salesforceDealNameInput"
        const val projectDescriptionInput = "projectDescriptionInput"
    }

    object MSA {
        const val MsaProjectDefaultDescription = "Company will ship equipment indicated in Deliverables to Customer, and will retain full incentive payment(s) associated with Efficiency Measures indicated in section 2.b as compensation for equipment and services provided."

        const val msaAddressOverwrite = "msaAddressOverwrite"
        const val msaStateOverwrite = "msaStateOverwrite"
        const val msaCityOverwrite = "msaCityOverwrite"
        const val msaZipOverwrite = "msaZipOverwrite"


        const val msaRebateProgramInput = "msaRebateProgramInput"
        const val msaAuthorizerNameInput = "msaAuthorizerNameInput"
        const val msaProjectDescriptionInput = "msaProjectDescriptionInput"

        const val msaEfficiencyMeasuresInput = "msaEfficiencyMeasuresInput"

        const val msaDeliverablePhaseInput = "msaDeliverablePhaseInput"
        const val msaDeliverableInput = "msaDeliverableInput"
        const val msaDeliverableDescriptionInput = "msaDeliverableDescriptionInput"
        const val msaDeliverableDueDateInput = "msaDeliverableDueDateInput"
    }

    object PROJECT_PROPOSAL {
        const val propBaselinekWhInput = "propBaselinekWhInput"
        const val propBaselineFixtureCountInput = "propBaselineFixtureCountInput"
        const val propProposedkWhInput = "propProposedkWhInput"
        const val propProposedFixtureCountInput = "propProposedFixtureCountInput"
        const val propProjectCostInput = "propProjectCostInput"
        const val propRebateAmountInput = "propRebateAmountInput"
        const val propStateInput = "propStateInput"
        const val propElectricityRateInput = "propElectricityRateInput"

        const val propUtilityRateInflationInput = "propUtilityRateInflationInput"
        const val propHVACInteractionSavingsInput = "propHVACInteractionSavingsInput"
        const val propHVACUpTimeInput = "propHVACUpTimeInput"
        const val propHPSMaintenanceInput = "propHPSMaintenanceInput"

        const val propAddFinancePageInput = "propAddFinancePageInput"
        const val propAddLeasingPageInput = "propAddLeasingPageInput"
    }

    object TIER_THREE {
        const val t3AddressOverwrite = "t3AddressOverwrite"
        const val t3StateOverwrite = "t3StateOverwrite"
        const val t3CityOverwrite = "t3CityOverwrite"
        const val t3ZipOverwrite = "t3ZipOverwrite"

        const val t3ProposalOverwrite = "t3ProposalOverwrite"
        const val t3RebatesOverwrite = "t3RebatesOverwrite"
        const val t3ProjectCostOverwrite = "t3ProjectCostOverwrite"
        const val t3TotalAnnualSavingsOverwrite = "t3TotalAnnualSavingsOverwrite"
        const val t3CummCashFlowListOverwrite = "t3CummCashFlowListOverwrite"
        const val t3AnnualizedROIOverwrite = "t3AnnualizedROIOverwrite"
        const val t3SimplePaybackOverwrite = "t3SimplePaybackOverwrite"

        const val tierGrRepInput = "tierGrRepInput"
        const val teirGrRepTitleInput = "teirGrRepTitleInput"

        const val tierEquipmentTypeInput = "tierEquipmentTypeInput"
        const val tierLightingInput = "tierLightingInput"
        const val tierDehumidifierInput = "tierDehumidifierInput"
        const val tierHeatCurtainInput = "tierHeatCurtainInput"
        const val tierHVACInput = "tierHVACInput"

        const val tierEquipmentPhase = "tierEquipmentPhase"
        const val tierEquipment = "tierEquipment"
        const val tierEquipmentNotes = "tierEquipmentNotes"
    }
}





